import { render, staticRenderFns } from "./MemberAllCountryBankInfo.vue?vue&type=template&id=22bb3bb0&"
import script from "./MemberAllCountryBankInfo.vue?vue&type=script&lang=js&"
export * from "./MemberAllCountryBankInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemberAllCountryBankInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports